import { render } from "./CheckPageSb.vue?vue&type=template&id=66754e74"
import script from "./CheckPageSb.vue?vue&type=script&lang=js"
export * from "./CheckPageSb.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__